import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, ResolveFn} from '@angular/router';
import {select, Store} from '@ngrx/store';
import {filter, Observable, take} from 'rxjs';
import {map, tap} from 'rxjs/operators';
import {selectOrganizationName} from '../state/organization/organization.selectors';
import {OrganizationActions} from '../state/organization/organization.actions';

export const organizationNameResolver: ResolveFn<string> = (__route: ActivatedRouteSnapshot): Observable<string> => {
  const store = inject(Store);

  return store.pipe(
    select(selectOrganizationName),
    tap(name => {
      if (name) return;
      store.dispatch(OrganizationActions.loadOrganizationName());
    }),
    filter(name => !!name),
    take(1),
    map(name => name!)
  );
};
